import { LogLevel } from '@wix/panorama-common-shared/types';
import { Hook } from '../hooks-manager';
import { calculateEnvironment, checkIsLocalMode, hasForcePanoramaReportQueryParam, RuntimeEnvironment } from '../../utils/environment-utils';
import { logToConsole } from '../../utils/console-utils';
const EXCLUDED_ENVIRONMENTS = [RuntimeEnvironment.DEVELOPMENT, RuntimeEnvironment.SLED];
export const environmentPlugin = () => _ref => {
  let {
    hooksManager,
    baseParams: {
      fullArtifactId,
      componentId
    }
  } = _ref;
  const environment = calculateEnvironment();
  const isLocalMode = checkIsLocalMode(fullArtifactId);
  const shouldSkipReporting = (EXCLUDED_ENVIRONMENTS.includes(environment) || isLocalMode) && !hasForcePanoramaReportQueryParam();
  if (shouldSkipReporting) {
    logToConsole(LogLevel.Info, fullArtifactId, componentId, `Local mode detected${fullArtifactId ? ` for ${fullArtifactId}` : ''}. Panorama will log reports in the console.`);
  }
  hooksManager.tap(Hook.beforeReport, eventPayload => {
    const {
      data,
      message,
      fullArtifactId: messageFullArtifactId,
      componentId: messageComponentId,
      logLevel
    } = eventPayload;
    if (shouldSkipReporting) {
      logToConsole(logLevel, messageFullArtifactId, messageComponentId, message || '', data);
      return false;
    }
    return;
  });
};
//# sourceMappingURL=environment-plugin.js.map